import axios from 'axios'
import { useState } from 'react'
import { apiStatus } from '../constants/apiStatus'
import { apiUrl, axiosDefaultHeader, baseUrl, stage } from '../constants/apiUrl'
import { loadStatus } from '../constants/loadStatus'
import { errorMsg } from '../constants/messages'
import type { Result } from '../interfaces/Result'
import { useAuth } from './useAuth'

interface C103PasswordUpdateProps {
  execPasswordUpdate: (
    loginId: string,
    currentPassword: string,
    newPassword: string,
    urlToken?: string,
    token?: string,
  ) => Promise<Result>
  loading: loadStatus
}
// C103 パスワード更新API呼出
export const useC103PasswordUpdate = (): C103PasswordUpdateProps => {
  const [loading, setLoading] = useState(loadStatus.NONE)
  const auth = useAuth()
  const execPasswordUpdate = async (
    loginId: string,
    currentPassword: string,
    newPassword: string,
    urlToken?: string,
    token?: string,
  ) => {
    try {
      setLoading(loadStatus.LOADING)
      const jwt = token ? token : await auth.getJwt()
      let body = {}
      if (jwt === '') {
        setLoading(loadStatus.LOADED)
        //return { success: false, message: errorMsg.SESSION_ERROR }
      }

      // ヘッダ作成
      const header = Object.assign(axiosDefaultHeader, {
        Authorization: 'Bearer ' + jwt,
      })
      if (currentPassword !== '') {
        // ボディ作成
        body = { current_pass: currentPassword, new_pass: newPassword }
      } else {
        // ボディ作成
        body = { new_pass: newPassword, token: urlToken }
      }

      const response = await axios.put(
        `${baseUrl}${stage}${apiUrl.usersPath}${loginId}/password`,
        body,
        {
          headers: header,
          validateStatus: () => true,
        },
      )

      if (response.status === apiStatus.SUCCESS) {
        // console.log(response.data);
        setLoading(loadStatus.LOADED)
        return { success: true }
      }
      setLoading(loadStatus.LOADED)
      if (response.data && response.data.message) {
        return {
          success: false,
          status: response.status,
          message: response.data.message,
        }
      }
      return {
        success: false,
        status: response.status,
        message: errorMsg.SYSTEM_ERROR,
      }
    } catch (error) {
      // console.log(error);
      setLoading(loadStatus.LOADED)
      return { success: false, message: errorMsg.SYSTEM_ERROR }
    }
  }

  return { execPasswordUpdate, loading }
}
